import React from 'react';
import {PfImage} from '@profabric/react-components';
import ContentHeader from '../content-header/ContentHeader';

const Loader = ({title}) => {
  return (
    <div>
      <div
        style={{height: '50vh', display: 'flex'}}
        className=" flex-column justify-content-center align-items-center"
      >
        <PfImage
          className="animation__shake"
          src="/img/logo.png"
          alt="ArtzenWiseLogo"
          height={100}
          width={100}
        />
      </div>
    </div>
  );
};

export default Loader;
